import baseUrl from './base';

export const postRelance = () => `${baseUrl}/relances`;
